import Select from 'bcl/components/input/select';
const options = [
  // TODO: wieder aktivieren, wenn die API fertig ist
  // {
  //   value: 'price',
  //   name: 'Lieferantenpreis',
  // },
  // {
  //   value: 'gross_price',
  //   name: 'Verkaufspreis',
  // },
  // {
  //   value: 'ordered_amount',
  //   name: 'Bestellte Menge',
  // },
  // {
  //   value: 'target_amount',
  //   name: 'Soll-Menge',
  // },
  {
    value: 'available_amount',
    name: 'Ist-Menge',
  },
  // {
  //   value: 'standard_order',
  //   name: 'Standardbestellung',
  // },
];
<template>
  <Select
    @name="stats"
    @label="Statistik"
    @options={{options}}
    @value={{@selectedStat}}
    @onChange={{@onChange}}
  />
</template>
